__webpack_require__.p = "/react_memoria/";